window.addGiftProduct = {
  init(element,isAjaxCart = false){
    addGiftProduct.doGiftProductAddActions(element,isAjaxCart);
  },
  getGiftProductData(element){
    element.querySelector('.giftProductHiddenElement').classList.add('listener');
    var dataset = element.querySelector('.giftProductHiddenElement').dataset;
    return {
      addGiftProduct: dataset.addGiftProduct,
      enableGiftProduct : dataset.enableGiftProduct,
      giftProductAdded : dataset.giftProductAdded,
      giftVarinatId : dataset.giftVarinatId,
      productIds : dataset.productIds
    }
  },
  doGiftProductAddActions(element,isAjaxCart){
    var getGiftProductData = addGiftProduct.getGiftProductData(element);
    console.log(addGiftProduct);

    if(getGiftProductData.enableGiftProduct == 'true' && getGiftProductData.addGiftProduct == 'true' && getGiftProductData.giftProductAdded == 'false'){
      console.log('addGiftProductToCart');
      addGiftProduct.addGiftProductToCart(getGiftProductData.giftVarinatId,isAjaxCart);
    }
    
    if(getGiftProductData.addGiftProduct == 'false' && getGiftProductData.giftProductAdded == 'true'){
      console.log('removeGiftProduct');
      addGiftProduct.removeGiftProduct(getGiftProductData.giftVarinatId,isAjaxCart);
    }
  },
  addGiftProductToCart(giftVarinatId,isAjaxCart){

    // document.querySelector('[loading-for-ajaxdrawer]').style.display = 'block';
    // document.body.classList.contains('template-cart') ? document.querySelector('[loading-for-quickview]').style.display = 'block': false ;
    
    var item = {
      id: giftVarinatId,
      quantity : 1,
      properties : {
        "gift_product":true
      }
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(item)
    })
    .then((res) => { return res.json() })
    .then((response) => {
      console.log(response);
      addGiftProduct.updateHtml(isAjaxCart);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  },
  removeGiftProduct(giftVarinatId,isAjaxCart){
    
    // document.querySelector('[loading-for-ajaxdrawer]').style.display = 'block';
    // document.body.classList.contains('template-cart') ? document.querySelector('[loading-for-quickview]').style.display = 'block': false ;
    
    var item = {
      id: giftVarinatId,
      quantity : 0,
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(item)
    })
    .then((res) => { return res.json() })
    .then((response) => {
      console.log(response,'Gift Removed');
      addGiftProduct.updateHtml(isAjaxCart);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  },
  updateHtml(isAjaxCart){
    fetch(routes.cart_url)
    .then((res) => {return res.text()})
    .then((data) => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(data, 'text/html');
      console.log("dp_cart",document.querySelector('[data-cart-items]').innerHTML);
      if(window.location.pathname == '/cart'){
        document.querySelector('#main-cart-items').innerHTML = doc.querySelector('#main-cart-items').innerHTML;
      }
      document.querySelector('[data-cart-items]').innerHTML = doc.querySelector('[data-cart-items]').innerHTML;
      // document.querySelector('[data-cart-items]').innerHTML = doc.querySelector('[data-items-wrapper]').innerHTML;
      // console.log(doc.querySelector('#main-cart-items'),doc.querySelector('[data-items-wrapper]'));
      const recommendationsElementMobile = document.querySelector('product-recommendations-mob');
      console.log("recommendationsElementMobile",recommendationsElementMobile);

      const updateRecommendations = (element, target) => {
        if (element && element.dataset.url) {
          const url = element.dataset.url;
          
          fetch(url)
            .then((response) => response.text())
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const recommendations = doc.querySelector(`#${target}`);
              
              if (recommendations && recommendations.innerHTML.trim().length) {
                element.replaceWith(recommendations);
                element.classList.add('product-recommendations--loaded');
                
                // Initialize quick view functionality
                if (typeof ella !== 'undefined' && ella.initQuickView) {
                  ella.initQuickView();
                }
                
                // Add click listeners to add-to-cart buttons
                recommendations.querySelectorAll(".add-to-cart").forEach((button) => {
                  button.addEventListener("click", function(event) {
                    event.preventDefault();
                    add(event);
                  });
                });
              } else {
                // No recommendations available
                if (dropdown_cart) dropdown_cart.classList.add('hide_related');
                if (relatedContent) relatedContent.classList.remove('show_related');
              }
            })
            .catch((error) => {
              console.error('Error updating recommendations:', error);
              if (dropdown_cart) dropdown_cart.classList.add('hide_related');
              if (relatedContent) relatedContent.classList.remove('show_related');
            });
        }
      };
      console.log("updateRecommendations",updateRecommendations);

      if (recommendationsElementMobile) {
        updateRecommendations(recommendationsElementMobile, "product-recommendations-mob");
      }
      
      // document.querySelector('[loading-for-ajaxdrawer]').style.display = 'none';
      // document.body.classList.contains('template-cart') ? document.querySelector('[loading-for-quickview]').style.display = 'none' : false;
      console.log("cart updated..");
      //       new CartItems();
      customElements.upgrade(document.querySelector('[data-cart-items]'));
      isAjaxCart === true ? window.ajaxDrawer.onLoadAddListeners() : false ;
      document.body.classList.contains('template-cart') ? new CartItems() : false;
      //       customElements.define('cart-items', CartItems);
    })
  }
}